import React, { Component } from "react";
import './styles.scss';
import { withLocalize } from "react-localize-redux";
import { Route, Switch } from 'react-router-dom';
import SearchAdvanced from "./search-advanced/index";
import SetupAnalysis from "./setup-analysis/index";
import MainSearch from "./main-search/index";

class DetailedSearch extends Component {
    render() {
        return(
            <div className='detailed-search'>
                <div className='logo-search-top'>
                    <img alt='logo' src='/img/ic_logo_w.svg' />
                </div>
                <Switch>
                    <Route path="/detailed-search" exact   component={MainSearch} />
                    <Route path="/detailed-search/result" component={SearchAdvanced} />
                    <Route path="/detailed-search/setup" component={SetupAnalysis} />
                </Switch>
            </div>
        )
    }
}

export default withLocalize(DetailedSearch);
